import trainingmain       from '../pages/training/training-main/TrainingMain.vue'
import training       from '../pages/training/training-main/TrainingMain.vue'
import traininglsit       from '../pages/training/list'
import trainingdetail       from '../pages/training/detail'


export default [
    {
        path: '/trainingmain',
        name: 'trainingmain',
        component: trainingmain,
    },
    {
        path: '/training',
        name: 'training',
        component: training,
    },
    {
        path: '/traininglsit',
        name: 'traininglsit',
        component: traininglsit,
    },
    {
        path: '/trainingdetail',
        name: 'trainingdetail',
        component: trainingdetail,
    },

]
